/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + ({"54":"primary-source-js","63":"zoom-out-js","124":"delete-js","156":"src-components-alert-pharos-alert-wc-stories","238":"sound-high-js","279":"edit-js","312":"profile-js","350":"mode-paging-js","484":"workspace-selected-js","649":"src-components-tabs-pharos-tabs-wc-stories","752":"link-external-js","806":"share-js","933":"zoom-in-js","1042":"checkmark-js","1154":"filetype-ppt-js","1167":"src-components-toggle-button-group-pharos-toggle-button-group-wc-stories","1228":"image-js","1343":"src-components-radio-group-pharos-radio-group-wc-stories","1421":"shift-up-js","1466":"src-components-breadcrumb-pharos-breadcrumb-wc-stories","1644":"src-components-heading-pharos-heading-wc-stories","1682":"src-components-radio-button-pharos-radio-button-wc-stories","1715":"play-js","1788":"src-components-tooltip-pharos-tooltip-wc-stories","1873":"save-js","1968":"view-grid-js","2096":"saved-js","2383":"src-components-text-input-pharos-text-input-wc-stories","2444":"fullscreen-minimize-js","2459":"filetype-pdf-js","2490":"question-inverse-js","2512":"linkedin-js","2573":"src-components-checkbox-group-pharos-checkbox-group-wc-stories","2695":"email-js","2787":"src-components-modal-pharos-modal-wc-stories","2800":"ellipses-horizontal-js","2826":"move-js","2831":"src-pages-item-detail-wc-item-detail-pages-stories","2838":"academic-content-js","2898":"chevron-right-js","2988":"checkmark-inverse-js","3065":"exclamation-js","3093":"laptop-js","3095":"pause-large-js","3144":"src-components-link-pharos-link-wc-stories","3209":"folder-js","3314":"expand-js","3670":"tumblr-js","3695":"chevron-left-js","3746":"exclamation-inverse-js","3902":"src-components-dropdown-menu-pharos-dropdown-menu-wc-stories","3968":"ellipses-vertical-js","4085":"src-components-sidenav-pharos-sidenav-wc-stories","4292":"folder-selected-js","4308":"link-js","4406":"calendar-js","4708":"view-gallery-js","4720":"audio-js","4751":"twitter-js","4778":"shift-left-js","4795":"pause-js","4832":"src-components-combobox-pharos-combobox-wc-stories","4894":"arrow-up-js","5010":"menu-js","5209":"workspace-js","5213":"video-js","5297":"google-js","5567":"src-components-header-pharos-header-wc-stories","5866":"partial-circle-js","5987":"view-list-js","6073":"collapse-js","6111":"play-large-js","6143":"src-pages-search-wc-search-pages-stories","6157":"book-js","6239":"close-inverse-js","6348":"src-components-input-group-pharos-input-group-wc-stories","6368":"shift-right-js","6454":"fit-to-view-js","6466":"src-components-icon-pharos-icon-wc-stories","6517":"filetype-zip-js","6589":"src-components-pagination-pharos-pagination-wc-stories","6705":"src-components-select-pharos-select-wc-stories","6807":"search-js","6994":"src-components-checkbox-pharos-checkbox-wc-stories","7125":"seek-backward-js","7430":"src-components-textarea-pharos-textarea-wc-stories","7437":"google-color-js","7440":"src-components-dropdown-menu-nav-pharos-dropdown-menu-nav-wc-stories","7510":"src-components-progress-bar-pharos-progress-bar-wc-stories","7524":"src-styles-tokens-wc-stories","7557":"youtube-js","7571":"src-styles-sass-wc-stories","7694":"seek-forward-js","7802":"arrow-down-js","7823":"info-inverse-js","7881":"chevron-down-js","7932":"src-components-image-card-pharos-image-card-wc-stories","7951":"chevron-right-large-js","8024":"download-js","8048":"arrow-right-js","8051":"chevron-up-js","8071":"arrow-left-js","8256":"src-components-layout-pharos-layout-wc-stories","8283":"docs-1-intro-docs-stories-mdx","8312":"src-components-loading-spinner-pharos-loading-spinner-wc-stories","8421":"checkmark-filled-circle-js","8698":"instagram-js","8745":"facebook-js","8810":"src-components-toast-pharos-toast-wc-stories","8828":"link-add-js","8848":"attachment-js","8882":"shift-down-js","8893":"folder-new-js","8970":"add-js","9010":"copy-js","9098":"chevron-left-large-js","9161":"src-components-footer-pharos-footer-wc-stories","9259":"mode-scrolling-js","9318":"docs-2-changelog-docs-stories-mdx","9320":"src-styles-typography-wc-stories","9330":"cite-js","9385":"fit-to-width-js","9416":"src-pages-home-wc-home-pages-stories","9493":"fullscreen-js","9506":"src-pages-reports-wc-reports-pages-stories","9670":"sound-low-js","9694":"close-js","9713":"new-js","9763":"base-js","9765":"src-components-button-pharos-button-wc-stories","9862":"circle-js","9925":"sound-none-js"}[chunkId] || chunkId) + "." + {"3":"95574f2b","18":"f41fb25a","54":"d59a870e","63":"72a109b3","124":"66c83193","156":"83f438c1","173":"1b81e9ac","238":"1349a74c","240":"797aa87e","279":"68954089","312":"8bf5e12b","350":"c5b329cc","394":"c42f10b5","484":"937ee608","509":"a0c69f2f","544":"73dfbd2e","556":"a21a2313","591":"02f512d9","649":"649db0b2","738":"799be7c6","752":"5842daf0","798":"361901fd","806":"506e0e79","886":"080c58dd","907":"afb47be9","914":"dd5ae48c","933":"7d4cf3d2","987":"2b634917","1042":"a5eb74f3","1154":"329c166a","1167":"5cd60806","1228":"20614af4","1289":"f5a42dae","1343":"0516fe29","1421":"a87c4b85","1466":"664d1684","1536":"da54a330","1543":"2c1485e8","1644":"6163c949","1672":"4dfc587a","1682":"ae79ede7","1715":"445d3049","1768":"418d2408","1788":"0742dffa","1789":"b267b19b","1873":"f7cbb9b0","1968":"a9320b1f","2007":"2b86eaef","2086":"7a19286c","2096":"406f8c54","2108":"0ba41535","2117":"38bb5840","2383":"ed639854","2444":"2c0b79dd","2459":"b36ead37","2490":"fe47bc8b","2512":"a590e886","2538":"22e749b3","2551":"b39a8c18","2568":"c1be05a8","2573":"03d495ff","2574":"2c44572c","2695":"d17d7ffb","2787":"c03db0ff","2797":"f4e2b3ab","2800":"f2c0c36c","2826":"37046c52","2831":"690ddd97","2837":"a768b4ea","2838":"cfcaaafa","2897":"bd071017","2898":"454fd128","2930":"7fae9e08","2988":"60011045","2994":"adfd57ec","3034":"8cf2db27","3055":"b781e01e","3065":"540c5e77","3093":"dc3b5347","3095":"9a5d2479","3137":"0ba0b558","3144":"ac7b1cb4","3209":"5875001c","3211":"23f2652d","3314":"0a4691a8","3372":"787e693c","3403":"01f07424","3443":"4f48366e","3535":"c1475282","3670":"5a4d26ad","3695":"5843b713","3732":"3e5dbe30","3746":"c2ee4134","3871":"77d242e4","3902":"7d4fb52b","3935":"de8fde9e","3968":"a988092d","4000":"1af28d29","4079":"fca17a61","4085":"41610b58","4095":"085317d5","4127":"b66bec1b","4192":"d575aa1c","4292":"a295412b","4308":"9a03f09e","4406":"818908b3","4664":"5ab7e694","4668":"93a54d5a","4671":"5abb256d","4708":"9ea7edd9","4720":"2b027e95","4751":"78a7d4a5","4778":"d1ba7a5b","4795":"b6dfc050","4832":"fe96bcc7","4869":"5a4436b8","4894":"6531a417","4975":"0c1b761f","4994":"b990ad05","5010":"b943e7a8","5050":"8e919055","5051":"04a90b0f","5072":"7482863b","5096":"1964ea5d","5209":"b73c0e70","5213":"e0437813","5229":"fa4f0659","5297":"2cf133d1","5527":"bf0ad218","5556":"972581d9","5567":"886682c4","5574":"35fb6262","5662":"29a011ab","5734":"de8d1538","5790":"503f03b0","5866":"1ac5f5fd","5890":"dfc8c55c","5935":"31b2f712","5987":"4cd4b3fc","6026":"35c206e9","6073":"92d60a96","6099":"0a8e14ba","6111":"d3e2626d","6143":"0d0ce64d","6157":"ebbb8faf","6236":"f6ee32f6","6239":"d9f7d4da","6241":"e952d526","6348":"de9b21cc","6368":"3b81b204","6454":"601f6481","6466":"15f29b70","6517":"6af4e081","6575":"1a5b1f49","6589":"c434df3a","6701":"b77ec277","6705":"549744db","6744":"598ad747","6807":"992f368b","6945":"14b2f1a3","6994":"7f1eb881","7040":"b7f0cc6a","7125":"abbf1d1f","7163":"b1d19a5b","7203":"37c07115","7280":"b487e29d","7282":"54ecc30b","7312":"63ff9bcb","7430":"e6153b94","7437":"3caa086e","7440":"12b4ba8c","7509":"75bc295a","7510":"1a6acd17","7524":"e0bcf13d","7541":"e2ee4185","7557":"858f8142","7571":"aace0337","7665":"073cbdd5","7694":"ea312e01","7802":"f0529748","7819":"23887147","7823":"f00df059","7881":"f4d0c9f5","7932":"fe41335d","7951":"ab887d4f","8024":"5a0079b4","8048":"53c95b24","8051":"59b5e2eb","8062":"fcc49ecf","8071":"78daa0dc","8072":"5b6c7aad","8255":"e7da3e88","8256":"dd174a53","8283":"6ece8a81","8312":"40f29e9e","8380":"ef4c14cf","8421":"5a4c42c6","8611":"fa8a7fca","8621":"7d6e1677","8692":"1dbbdda8","8698":"0fc37d61","8745":"8982c1a8","8747":"b84773c8","8786":"316cca96","8797":"a36af8a7","8810":"0e0affa9","8828":"eac4445a","8848":"8dc688c4","8882":"d9b23711","8893":"fba48a45","8919":"1de66125","8931":"1827f267","8970":"0fee7cba","9010":"bf0d0b1e","9081":"3631be91","9098":"dc38dd84","9115":"fd320400","9161":"d2165929","9259":"22aafa52","9318":"f58660d2","9320":"ff031a34","9330":"f50d2879","9348":"6a1ad931","9385":"b8b212bd","9416":"416bfa1d","9493":"7e9ee6b4","9506":"c9917ff0","9657":"bf229a2a","9670":"294fe561","9672":"1736db52","9694":"d3b00f5f","9698":"25ae55dd","9713":"529becc2","9763":"577b0581","9765":"5eda6cac","9807":"859473b6","9841":"ec1611ac","9862":"66b85c65","9925":"8e923e5f","9947":"44f7139d"}[chunkId] + ".iframe.bundle.js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "pharos:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			1303: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(1303 != chunkId) {
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkpharos"] = self["webpackChunkpharos"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	
/******/ })()
;